/* eslint-disable no-prototype-builtins */
import { disposeMesh } from 'src/utils/object3DHelpers';
import { LoadingState } from '../../types';
import { emojiKeyMap, findObject3DChildByName } from './utils';
import AbstractAvatar from './AbstractAvatar';

export class AvatarComponent extends AbstractAvatar {
  private avatarRoot: any;

  // private faceNode?: any; // nodes for current RPM version

  // private teethNode?: any;

  private wolf3DAvatar?: any; // nodes for old RPM versions

  async onInit() {
    if (!this.inputs.url?.length) return;
    this.outputs.loadingState = LoadingState.Loading;

    const THREE = this.context.three;
    this.initRoot();

    this.model = await this.loadModel(THREE, this.inputs.url);
    this.model.position.setY(-0.6);

    [this.avatarRoot] = this.model.children;
    // this.faceNode = findObject3DChildByName(this.avatarRoot, 'Wolf3D_Head');
    // this.teethNode = findObject3DChildByName(this.avatarRoot, 'Wolf3D_Teeth');
    this.wolf3DAvatar = findObject3DChildByName(this.avatarRoot, 'Wolf3D_Avatar');
    // console.log('this.avatarRoot', this.avatarRoot);
    // console.log('this.faceNode', this.faceNode);
    // console.log('this.teethNode', this.teethNode);
    // console.log('this.wolf3DAvatar', this.wolf3DAvatar);

    this.pivot.add(this.model);
    this.initLabel();

    this.outputs.loadingState = LoadingState.Loaded;
  }

  onDestroy() {
    if (this.label) {
      disposeMesh(this.label);
      this.label = null;
    }
  }

  // called back when any inputs properties change
  onInputsUpdated() {
    this.onInit();
  }

  updateFromResults(prediction: any) {
    if (!this.model) return;

    this.updateMorphTargets(prediction.blendShapes);
    if (prediction?.rotation) {
      this.updateHeadRotation(
        -(prediction.rotation.pitch || 0),
        -(prediction.rotation.yaw || 0),
        -(prediction.rotation.roll || 0),
      );
    }
    // this.updatePosition(prediction.transform.x, prediction.transform.y, prediction.transform.z);
  }

  private updateMorphTargets(targets: any) {
    // Object.keys(targets).forEach((key) => {
    //   const value = targets[key];
    //   setMorphTarget(this.faceNode, key, value);
    //   setMorphTarget(this.teethNode, key, value);
    //   setMorphTarget(this.wolf3DAvatar, key, value);
    // });

    // temporary decision for avatar emotions
    Object.entries(targets).forEach(([key, value]: any) => {
      if (key === emojiKeyMap.jawOpen) {
        key = emojiKeyMap.mouthOpen;
        value *= 3;
      } else if (key === emojiKeyMap.mouthSmileLeft) {
        key = emojiKeyMap.mouthSmile;
      }

      const index = this.wolf3DAvatar.morphTargetDictionary[key];
      this.wolf3DAvatar.morphTargetInfluences[index] = value;
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars,class-methods-use-this
  private updateHeadRotation(pitch: number, yaw: number, roll: number) {
    // Inverse yaw & roll effects for yourself to give mirror effect
    this.pivot.rotation.set(pitch, yaw, roll);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars,class-methods-use-this
  // private updatePosition(x?: number, y?: number, z?: number) {
  // const SCALE = 0.2;
  // const Y_OFFSET = 0;
  // this.avatarRoot?.position.set(x * SCALE, Y_OFFSET + y * SCALE, z);
  // }
}

export const avatarComponentType = 'mp.avatarComponent';
export const makeAvatarComponent = () => new AvatarComponent();
